import routerOptions0 from "/home/anh/project/outsource/alobacsi/clinic booking/user-web-app/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@18.19.50_eslint@8.57.0_ioredis@5.4.1_magicast@0_bowb55cx2v63qu5m7fdcfyisvi/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}